export function getAllSponsoredWidgetQueryIds() {
    const result = {};
    const queryParams = new URLSearchParams(window.location.search);
    const rawPreviews = queryParams
        .getAll('sw_preview')
        .flatMap((preview) => preview.split(',').map((p) => p.trim()));
    for (const preview of rawPreviews) {
        const match = preview.match(/^([a-zA-Z0-9-_]+)-(\d+)$/);
        if (match) {
            const [, type, id] = match;
            result[type] = id;
        }
    }
    return result;
}
